import { Component, OnInit } from "@angular/core";

@Component({
  selector: "report-value",
  templateUrl: "./report-value.component.html",
  styleUrls: ["./report-value.component.scss"],
})
export class ReportValueComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
